module.exports = "/_next/static/images/0a8862f480096202520bb8c987c6cacc-handEmail.svg.webp";